import React from 'react'
import {Flex, Text, useStyleConfig} from '@chakra-ui/react'
import {remCalc} from '../../../theme/_utils'
import PropTypes from 'prop-types'
//import useDamImage from '../../../custom-hooks/use-dam-image'
import CategoryFilterCardContainer from './category-filter-card-container'

const defaultHexColor = '#D9DCDE'
const defaultTextColor = '#484956'

const colorTextMap = {
    '#E2DCD5': '#39342D',
    '#EFE0DD': '#440707',
}

const getCardTextColor = ({hasImage, hexColor}) => {
    if (hasImage) {
        return 'white'
    }

    return colorTextMap[hexColor?.toUpperCase()] || defaultTextColor
}

const CategoryFilterCard = ({
    refinement,
    attributeId,
    filterLabel,
    toggleFilter,
    selectedFilters = [],
    isFirstCard = false,
    isLastCard = false,
}) => {
    const isChecked = selectedFilters.includes(refinement?.value)
    const styles = useStyleConfig('CategoryCardFilters', {})
    const selectedCardMargin = {
        base: remCalc(3),
        sm: remCalc(3),
        md: remCalc(4),
        lg: remCalc(4),
    }

    const description =
        typeof refinement?.description === 'string' ? refinement.description.trim() : ''
    const isHexColor = description.startsWith('#')
    const imageUrl = !isHexColor && description !== '' ? description : ''
    const hexColor = isHexColor ? description : defaultHexColor
    const hasImage = imageUrl !== ''
    const textColor = getCardTextColor({hasImage, hexColor})
    //  const damImage = useDamImage(imageUrl)

    if (refinement?.hitCount === 0 && !isChecked) {
        return null
    }

    const handleToggleFilter = () => {
        if (!toggleFilter || !refinement?.value || !attributeId) {
            return
        }

        toggleFilter(refinement, attributeId, filterLabel, isChecked, true, 'card')
    }

    return (
        //The Container was created to simulated the box shadow. There was a bug with the box shadow
        <CategoryFilterCardContainer
            isActive={isChecked}
            borderRadius={styles?.card?.borderRadius || 'large-1'}
            marginLeft={isChecked && !isFirstCard ? selectedCardMargin : 0}
            marginRight={isChecked && !isLastCard ? selectedCardMargin : 0}
        >
            <Flex
                as="button"
                type="button"
                onClick={handleToggleFilter}
                w="100%"
                maxW={remCalc(390)}
                minH={{
                    base: remCalc(110),
                    sm: remCalc(110),
                    md: remCalc(239),
                    lg: remCalc(239),
                }}
                alignItems="center"
                justifyContent="center"
                aria-pressed={isChecked}
                {...styles?.card}
                background={
                    hasImage ? `url(${imageUrl}) lightgray 50% / cover no-repeat` : `${hexColor}`
                }
                backgroundSize="cover"
            >
                <Text {...styles?.cardText} color={textColor}>
                    {refinement.label}
                </Text>
            </Flex>
        </CategoryFilterCardContainer>
    )
}

CategoryFilterCard.propTypes = {
    refinement: PropTypes.object,
    attributeId: PropTypes.string,
    filterLabel: PropTypes.string,
    toggleFilter: PropTypes.func,
    selectedFilters: PropTypes.array,
    isFirstCard: PropTypes.bool,
    isLastCard: PropTypes.bool,
}

export default CategoryFilterCard
